export const userJoinSession = (state) => state.SessionReducer.userJoinSession;

export const userSessionName = (state) =>
  state.SessionReducer.sessionDetails.sessionName;

export const Session = (state) => state.SessionReducer.sessionDetails;